import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { DatabaseService } from '../../core/services/database.service';
import { navigateTo, reloadPage } from '../../core/utils/reload';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error.component.css',
})
export class ErrorComponent implements OnInit {
  errorMessage = 'We encountered an unexpected error while loading your data.';
  showReloadButton = false;
  errorType: 'generic' | 'opfs-lock' | 'malformed-db' = 'generic';

  constructor(
    private authService: AuthService,
    private router: Router,
    private db: DatabaseService,
  ) {}

  ngOnInit(): void {
    // Check if database initialization failed
    const dbError = this.db.initError;
    if (
      dbError?.message.includes('createSyncAccessHandle') ||
      dbError?.message.includes('Access Handle') ||
      dbError?.message.includes('NoModificationAllowedError')
    ) {
      // OPFS SAH Pool lock conflict — should be rare after the SharedWorker
      // conversion but can still occur on first load if a previous SharedWorker
      // instance hasn't fully shut down yet.
      this.errorType = 'opfs-lock';
      this.errorMessage =
        'The database is locked by another CheckPoint tab or window. ' +
        'Close all other CheckPoint tabs, then reload this page.';
      this.showReloadButton = true;
    } else if (dbError?.message.includes('database disk image is malformed')) {
      this.errorType = 'malformed-db';
      this.errorMessage =
        "Database initialization failed. This may indicate a problem with the browser's " +
        'storage. Try using a different browser or clearing all site data.';
      this.showReloadButton = false;
    }
  }

  /**
   * Reload the page to retry with fresh database
   */
  reloadPage(): void {
    reloadPage('user clicked reload on error page');
  }

  /**
   * Clear local data and redirect to landing page
   */
  async resetAndRestart(): Promise<void> {
    // Clear auth token
    this.authService.logout();

    // Reload page to clear all state
    navigateTo('/landing', 'error page reset and restart');
  }

  /**
   * Just go to landing page without clearing data
   */
  async goToLanding(): Promise<void> {
    await this.router.navigate(['/landing']);
  }
}
